/**
 * @fileoverview ModalFooter component for the metadata edit modal.
 * Provides action buttons for saving or canceling changes.
 */

import { useTranslation } from "@/i18n";

/**
 * Props for the ModalFooter component.
 */
interface ModalFooterProps {
  /** Callback when the cancel button is clicked */
  readonly onCancel: () => void;
  /** Callback when the save button is clicked */
  readonly onSave: () => void;
}

/**
 * ModalFooter displays action buttons at the bottom of the edit modal.
 * Provides consistent styling and layout for modal footer actions.
 *
 * @param props - Component props
 * @returns Modal footer UI with cancel and save buttons
 */
export default function ModalFooter({ onCancel, onSave }: ModalFooterProps) {
  const { t } = useTranslation();

  return (
    <div className="px-6 py-6 border-t border-[#e4e4e7] flex justify-end items-center gap-2">
      <div className="flex gap-2">
        <button
          onClick={onCancel}
          className="px-3 py-1 bg-white border border-[#e4e4e7] text-[#18181b] text-sm font-semibold rounded-lg hover:bg-[#f4f4f5] transition-colors"
        >
          {t("common.buttons.cancel")}
        </button>
        <button
          onClick={onSave}
          className="px-3 py-1 bg-[#8e2bf0] text-white text-sm font-semibold rounded-lg hover:bg-[#8e2bf0] transition-colors"
        >
          {t("common.buttons.save")}
        </button>
      </div>
    </div>
  );
}
